import { makeStyles, TableCell as MUITableCell } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import { styledBy } from "../../../../utils/styles";

const useStyle = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1.25, 2.5, 1.25, 2.5),
    fontWeight: 600,
    ...theme.typography.body2,
    color: styledBy("color", theme.palette.ascents),
    border: "none",

  },
}));

const TableCell = ({ color, className, align = 'left', ascent = "primary", ...props }) => {
  const classes = useStyle({
    ascent,
    color,
  });

  return <MUITableCell align={align} {...props} className={clsx(classes.root, className)} />;
};

TableCell.propTypes = {};

export default TableCell;
